import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=2a857a24"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Currency: require('/vercel/path0/components/partials/Currency.vue').default,Info: require('/vercel/path0/components/common/Info.vue').default,Card: require('/vercel/path0/components/common/Card.vue').default})
